export const DATABASE_TYPE = process.env.REACT_APP_DB_CONFIG;
export const PTS_DATABASE = 'PTS';
export const AGENCY_COLORED = 'AGENCY_COLORED';
export const AGENCY_GRAYED = 'AGENCY_GRAYED';
export const DEPARTMENT_COLORED = 'DEPARTMENT_COLORED';
export const DEPARTMENT_GRAYED = 'DEPARTMENT_GRAYED';
